
import React, { useState } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    TextField
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';
import {RecordModel,
        LayoutFieldModel} from '../../models/models';
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {LookupDialogComponent} from "./LookupDialog";
import {checkLayoutFieldRequirement} from '../../utils/fieldValidations';

export const LookupFieldComponent: React.FC<{
  layoutField: LayoutFieldModel,
  value: string,
  onSelect: (layoutField: LayoutFieldModel) => void,
  onChange: (value: RecordModel | null, layoutField: LayoutFieldModel) => void,
}> = ( {
  layoutField,
  value,
  onSelect,
  onChange
}) => {

  const [openLookupDialog, setOpenLookupDialog] = useState<boolean>(false);
  const [lookupFieldObject, setLookupFieldObject] = useState<string | null>(null);

  const handleSearch = () => {
    setLookupFieldObject(layoutField.ReferencedField_sys.ReferencedObject_sys.ApiName_sys);
    setOpenLookupDialog(!openLookupDialog);
  }

  const handleChange = (newLookupValue: RecordModel | null) => {
      onChange(newLookupValue, layoutField)
      setLookupFieldObject(null)
      setOpenLookupDialog(false)

  }

  const required = checkLayoutFieldRequirement(layoutField)

  const error = () => {
    if(required &&
       (!value || value == "\"\"")){
         return true
       }
    return false
  };

  return (
    <>
      <LookupDialogComponent
        objectApiName={lookupFieldObject}
        openDialog={openLookupDialog}
        onCloseDialog={() => {
              setLookupFieldObject(null)
              setOpenLookupDialog(false)
            }}
        onSelect={handleChange}
      />

      <TextField
         fullWidth
         disabled
         error={error()}
         required={required}
         size="small"
         label={layoutField.ReferencedField_sys.Label_sys}
         variant="filled"
         value={value}
         helperText={layoutField.ReferencedField_sys.HelpText_sys}
         inputProps={{
           maxLength: layoutField.ReferencedField_sys.Length_sys,
           onClick: () => console.log("field clicked")
         }}
         InputProps={{
           disableUnderline: true,
           startAdornment:(
              <InputAdornment position="start">
                <IconButton
                   disabled={value === undefined || null ? true : false}
                   size="small"
                   onClick={() => onSelect(layoutField)}>
                     <OpenInNewIcon />
                 </IconButton>
            </InputAdornment>
           ),
           endAdornment: (
             layoutField.AccessSetting_sys !== 'read' &&
              <InputAdornment position="end">
                 <IconButton size="small" onClick={() => handleSearch()}>
                 <SearchIcon />
                </IconButton>
            </InputAdornment>
        ),
         }}
      />
      </>
    );
};
